import Button from "../../../Atoms/Button";
import {useMutation, useQuery} from "@apollo/client";
import {GetAdventures, GetAdventures4User} from "../../../GraphQL/AdventureQueries";
import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {RootState} from "../../../redux/store";
import {setActiveContent, setIsAppLoading} from "../../../redux/slices/content/contentSlice";
import {toast} from "react-toastify";
import {AddSharp, DeleteOutlineSharp, DeleteSharp, PlayArrowSharp, SearchSharp} from "@mui/icons-material";
import {ActiveContent} from "../../../redux/slices/content/contentType";
import {deleteAdventure} from "../../../GraphQL/AdventureMutation";
import {setAdventure} from "../../../redux/slices/adventure/adventureSlice";
import {AdventureState} from "../../../redux/slices/adventure/adventureType";
import {UpdateLastHostedAdventure, UpdateLastPlayedAdventure} from "../../../GraphQL/UserMutations";
import {updateLastHosted} from "../../../redux/slices/user/userSlice";
import {VeneList} from "../../../Atoms/VeneList";
import {Race} from "../../../redux/slices/character/characterType";

export const Adventure = () => {
    const dispatch = useAppDispatch()
    const user = useAppSelector((state: RootState) => state.user)

    const {data: adventureData, loading: adventureLoading, error: adventureError} = useQuery(GetAdventures, {
        skip: user.role < 3,
        fetchPolicy: 'network-only'
    })

    const {
        data: adventure4UserData,
        loading: adventure4UserLoading,
        error: adventure4UserError
    } = useQuery(GetAdventures4User, {
        variables: {
            userId: Number(user.userId)
        },
        skip: user.role > 2,
        fetchPolicy: 'network-only'
    })

    const [
        deleteAdventureHook, {
            data: deleteAdventureData,
            loading: deleteAdventureLoading,
            error: deleteAdventureError
        } ] = useMutation(deleteAdventure);

    const [ updateLastHostedHook, {
        loading: updateLastHostedLoading,
        error: updateLastHostedError
    }] = useMutation(UpdateLastHostedAdventure)

    const [ adventures, setAdventures ] = React.useState<any[]>([]);

    useEffect(() => {
        if (updateLastHostedLoading) {
            dispatch(setIsAppLoading({loadingText: "Speichere Last Played Referenz", isAppLoading: true}))
        } else {
            dispatch(setIsAppLoading({loadingText: "", isAppLoading: false}))
        }
    }, [updateLastHostedLoading]);

    useEffect(() => {
        if (updateLastHostedError) {
            toast("Fehler beim Speichern der Last Played Referenz")
        }
    }, [updateLastHostedError]);

    useEffect(() => {
        if (adventureData && !adventureLoading) {
            setAdventures(adventureData.getAdventures)
        }
    }, [ adventureData ])

    useEffect(() => {
        if (adventure4UserData && !adventure4UserLoading) {
            setAdventures(adventure4UserData.getAdventure4User)
        }
    }, [ adventure4UserData ])

    useEffect(() => {
        dispatch(setIsAppLoading({
            isAppLoading: adventureLoading,
            loadingText: adventureLoading ? 'Abenteuer werden geladen...' : ''
        }))
    }, [ adventureLoading ])

    useEffect(() => {
        dispatch(setIsAppLoading({
            isAppLoading: adventure4UserLoading,
            loadingText: adventure4UserLoading ? 'Ihre Abenteuer werden geladen...' : ''
        }))
    }, [ adventure4UserLoading ])

    useEffect(() => {
        if (adventure4UserError) {
            toast('Beim Laden der Abenteuer ist ein Fehler aufgetreten')
        }
    }, [ adventure4UserError ])

    useEffect(() => {
        if (adventureError) {
            toast('Beim Laden der Abenteuer ist ein Fehler aufgetreten')
        }
    }, [ adventureError ])

    useEffect(() => {
        if (deleteAdventureData && !deleteAdventureLoading) {
            if (!deleteAdventureError && deleteAdventureData.deleteAdventure) {
                toast('Abenteuer erfolgreich gelöscht!')
            }
            if (deleteAdventureError && !deleteAdventureData.deleteAdventure) {
                toast('Abenteuer löschen fehlgeschlagen!')
            }
        }

    }, [ deleteAdventureData ])

    useEffect(() => {
        if (deleteAdventureError) {
            toast('Abenteuer löschen fehlgeschlagen!')
        }
    }, [ deleteAdventureError ])

    useEffect(() => {
        if (deleteAdventureLoading) {
            dispatch(setIsAppLoading({loadingText: 'Abenteuer wird gelöscht...', isAppLoading: true}))
        } else {
            dispatch(setIsAppLoading({loadingText: '', isAppLoading: false}))
        }
    }, [ deleteAdventureLoading ])

    const handleDeleteAdventure = async (adventureId: number) => {
        await deleteAdventureHook({
            variables: {
                adventureId: Number(adventureId)
            },
            refetchQueries: [
                {
                    query: GetAdventures
                } ]
        });
    }

    const handleEditAdventure = async (adventure: any) => {
        await updateLastHostedHook({
            variables: {
                adventureId: Number(adventure.adventureId),
                userId: Number(user.userId)
            }
        })
        
        dispatch(updateLastHosted(Number(adventure.adventureId)))
        
        dispatch(setAdventure({
            adventureId: adventure.adventureId,
            adventureDesc: adventure.adventureDescription,
            adventureName: adventure.adventureName,
            user_to_adventure: adventure.user_to_adventure
        }))
        dispatch(setActiveContent(ActiveContent.AdventureMask))
    }

    const renderOneAdventure = (adventure: any) => {
        return (
            <div className='row mt-3 custom-grid-wrapper'>
                <div className='col-3 custom-grid-col'>
                    <Button className='collapsed-sidebar-button' tooltip='Abenteuer spielen'
                            onClick={async () => await handleEditAdventure(adventure)}><PlayArrowSharp/></Button>
                    <Button className='collapsed-sidebar-button' tooltip='Abenteuer löschen'
                            onClick={async () => await handleDeleteAdventure(adventure.adventureId)}><DeleteOutlineSharp/></Button>
                </div>
                <div className='col-7 custom-grid-col'>
                    {adventure.adventureName}
                </div>
                <div className='col-2'>
                    {adventure.user_to_adventure.length}
                </div>
            </div>
        )
    }

    const renderAllAdventures = () => {
        const html = [];
        for (const adventure of adventures) {
            html.push(renderOneAdventure(adventure))
        }

        return html;
    }

    return (
        <div>
            <div className='row justify-content-center mt-3'>
                <div className='col-10 adventure-container'>
                    <div className='row justify-content-start mt-2'>
                        <div className='col-3'>
                            <Button onClick={() => dispatch(setActiveContent(ActiveContent.AdventureCreate))}
                                    style={{width: '200px'}}><AddSharp/> Abenteuer erstellen</Button>
                        </div>
                    </div>
                    <VeneList<AdventureState>
                        data={adventures}
                        colDefinition={[
                            {
                                colName: "Name",
                                keyName: "adventureName"
                            }
                        ]}
                        buttonConfig={[
                            {
                                icon: <PlayArrowSharp/>,
                                onClick: async (dataEntry) => { await handleEditAdventure(dataEntry) }
                            },
                            {
                                icon: <DeleteSharp/>,
                                onClick: async (dataEntry) => { await handleDeleteAdventure(dataEntry.adventureId) }
                            }
                        ]}
                    />
                </div>
            </div>
        </div>
    )
}